import { createContext } from "react";
import { WhoAmI } from "../@types/UserInfo";

const UserContext = createContext<WhoAmI | undefined>(undefined);

export default UserContext;
